import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CaseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Case",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m24.96 25.67 4.73-7.11c.65-.97.22-1.75-.95-1.75H10.02l-7.1 10.61h18.73c1.35-.07 2.53-.74 3.3-1.74Zm-.61-16.35c0-.59-.47-1.06-1.06-1.07h-4.67V6.41c0-1.01-.82-1.83-1.83-1.83H9.52c-1.01 0-1.82.82-1.82 1.83v1.84H3.07C2.48 8.25 2 8.73 2 9.32v15.65l6.56-9.85c.19-.28.51-.47.87-.47h14.88l.04-5.32ZM9.53 6.41h7.3v1.84h-7.3z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 16.71h-8a1.14 1.14 0 1 1 0-2.28H27V9.86c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v4.57h6.86a1.14 1.14 0 1 1 0 2.28H3c-.63 0-1.14-.51-1.14-1.14V9.86c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v5.71c0 .63-.51 1.14-1.14 1.14ZM25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43v-5.71a1.14 1.14 0 1 1 2.28 0v5.71c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14v-5.71a1.14 1.14 0 1 1 2.28 0v5.71c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 20.14c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0V19c0 .63-.51 1.14-1.14 1.14M20.14 8.71c-.63 0-1.14-.51-1.14-1.14V5.28c0-.63-.51-1.14-1.14-1.14h-4.57c-.63 0-1.14.51-1.14 1.14v2.29a1.14 1.14 0 1 1-2.28 0V5.28c0-1.89 1.54-3.43 3.43-3.43h4.57c1.89 0 3.43 1.54 3.43 3.43v2.29c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};